import React from 'react'
import moment from 'moment'
import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom'
import Card from '../core/Card'
import { Icon, BackIcon, BriefcaseIcon, CoinIcon, RefundIcon } from '../core/icons'
import { Button, Select, DatePicker, Icon as AIcon, Tag, Tooltip, Popover, Checkbox, Dropdown, Row, Col, message, Menu, Popconfirm } from 'antd';
import { connect } from 'react-redux'
import { withPreviousDate, getPurposes, getFilterCount } from './reducer'
import {
  mergeTransactions as merge,
  deleteTransactions as remove,
  batchClassify,
  showCheckboxes,
  untoggleAllTransactions as untoggleAll,
  selectAll
} from './actions'
import styled, {css, keyframes} from 'styled-components'
import PopconfirmOrPopover from '../core/PopconfirmOrPopover'

const { Option } = Select

const mapStateToProps = ({transactions, models})=>({
  ...transactions,
  favoritePlaces: models.places,
  transactions: withPreviousDate(models.transactions),
  purposes: getPurposes({models}),
  areFiltersApplied: getFilterCount(transactions.filterValues)>0
})

  const fadeIn = keyframes`
    from {
      margin-top: 30px;

      opacity: 0;
    }

    to {
      margin-top: inherit;

      opacity: 1;
    }
  `;

  const BulkActionsDiv = styled.div`
      margin-bottom: 20px;
      display: flex;

      ${'' /* .bulk-actions { */}
      button {
        font-size: 14px;
        text-transform: capitalize;
        margin-right: 10px;
      }


      ${props=>props.isSticky &&
        `
        margin-bottom: 0px;

        animation-duration: 0.6s;
        animation-name: ${fadeIn};
        background: white;
        `
      }
  `


const BulkActions = connect( mapStateToProps, {
  // actionCreators:
  batchClassify, untoggleAll, merge, remove, showCheckboxes, selectAll
})(
  // stateless component:
  ({
    isSticky, style,
    filter_params, untoggleAll, batchClassify, purposes,
    merge, remove, showCheckboxes, checkboxesVisible,
    // if there's any selected items:
    hasSelected=filter_params.token_ids.length>0,
    hasSelectedAll,
    selectAll,
    totalResultsCount,
    count = (hasSelectedAll&&totalResultsCount) || filter_params.token_ids.length,
    areFiltersApplied,
  }) =>
      !checkboxesVisible
      ? <BulkActionsDiv isSticky={isSticky}>
          <Button icon='check' onClick={showCheckboxes}>Select multiple</Button>
          { areFiltersApplied && <Button icon='check' onClick={selectAll}>Select All ({totalResultsCount})</Button>}
        </BulkActionsDiv>
      : hasSelected ?
        <BulkActionsDiv isSticky={isSticky}>
        <Button icon='check' onClick={untoggleAll}>Cancel</Button>

        <PopconfirmOrPopover
          shouldConfirm={hasSelectedAll}
          title={<span>Classify {count} transaction{count > 1 ? "s" : ""}:</span>}
          confirmTitle={`Are you sure you want to classify ALL ${count}?`}
          onConfirm={batchClassify}
          content={
            ({confirmThenHandle})=>
              <div>
                <p>Purpose:</p>
                <Select
                  style={{width: '100%'}}
                  onChange={confirmThenHandle}
                  placeholder="Classify as ..."
                >
                  {purposes.map(purpose=>
                    <Option key={purpose} value={purpose}>{purpose}</Option>
                   )}
                </Select>
              </div>
          }
        >
          <Button icon='edit'>Classify{hasSelectedAll && ` all ${count}`}</Button>
        </PopconfirmOrPopover>

        <Popconfirm title={`Are you sure you want to delete ALL ${count}?`} placement="bottom" onConfirm={()=>
          remove(filter_params)
          .then(()=>message.success('Deleted transactions successfully.', 10))
        } okText="Yes" cancelText="No">
          <Button icon='delete'>Delete{hasSelectedAll && ` all ${count}`}</Button>
        </Popconfirm>
      </BulkActionsDiv>
      : // else
      <BulkActionsDiv isSticky={isSticky}>
        <Button icon='close' onClick={untoggleAll}>Cancel</Button>
        <Button disabled style={{opacity: .4}} icon='edit'>Classify</Button>
        <Button disabled style={{opacity: .4}} icon='delete'>Delete</Button>

      </BulkActionsDiv>

)

export default BulkActions



// WEBPACK FOOTER //
// ./src/transactions/BulkActions.js